// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Lienzos a pantalla completa (Cableado › Tomas ↔ panel).
 *
 * Estas vistas no son listados: ocupan todo el alto útil entre las migas y el
 * borde inferior. Desde 2026-10-30 son rutas de \`isCanvasRoute\` (ver
 * \`MainLayout.jsx\`), así que el alto lo reparte el layout con flex y aquí no
 * hay \`calc()\` contra el viewport: un número fijo dejaba franjas muertas en
 * cuanto cambiaba el alto de la barra superior o de las migas.
 */

.cabling-fullpage {
  flex: 1 1;
  height: 100%;
  min-height: 0;
  overflow: hidden;
}

/* ── Topología de virtualización ─────────────────────────────────────────
   La barra tenía seis muestras de leyenda y cuatro botones en una fila que no
   se podía ni envolver ni desplazar: en un móvil, «Resumen» quedaba a 800 px
   de la pantalla. Ahora el título va en su línea, la leyenda se envuelve y los
   botones bajan debajo. */
@media (max-width: 900px) {
  .vtc-page {
    margin: -0.75rem !important;
    height: calc(100dvh - var(--app-topbar-h) - var(--app-crumb-h) - 1.5rem) !important;
  }

  .vtc-toolbar {
    flex-wrap: wrap;
    gap: 8px !important;
    padding: 8px 10px !important;
  }

  .vtc-title {
    flex: 1 1 100%;
    font-size: 0.86rem !important;
  }

  .vtc-legend {
    flex: 1 1 100%;
    flex-wrap: wrap;
    gap: 4px 10px !important;
  }
}

/* ── Topología de red (\`NetworkTopologyCanvas\`) ───────────────────────────
   La leyenda medía 417 px y el SVG se salía 10 px del contenedor: en un móvil
   se cortaban por la derecha. Ahora la leyenda envuelve y el SVG se ajusta al
   ancho (el contenido se ve con pan y zoom). */
@media (max-width: 900px) {
  .ntop-page {
    margin: -0.75rem !important;
    height: calc(100dvh - var(--app-topbar-h) - var(--app-crumb-h) - 1.5rem) !important;
  }

  .ntop-legend {
    flex: 1 1 100%;
    gap: 4px 8px !important;
  }

  .ntop-svg {
    width: 100% !important;
    max-width: 100% !important;
  }
}

/* Ayuda de uso del mapa de dependencias: en móvil el gesto es obvio y el texto
   no cabe (se cortaba a la derecha). */
@media (max-width: 768px) {
  .sdm-hint { display: none; }
}
`, "",{"version":3,"sources":["webpack://./src/styles/canvas-pages.css"],"names":[],"mappings":"AAAA;;;;;;;;EAQE;;AAEF;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,gBAAgB;AAClB;;AAEA;;;;0BAI0B;AAC1B;EACE;IACE,2BAA2B;IAC3B,mFAAmF;EACrF;;EAEA;IACE,eAAe;IACf,mBAAmB;IACnB,4BAA4B;EAC9B;;EAEA;IACE,cAAc;IACd,6BAA6B;EAC/B;;EAEA;IACE,cAAc;IACd,eAAe;IACf,wBAAwB;EAC1B;AACF;;AAEA;;;+CAG+C;AAC/C;EACE;IACE,2BAA2B;IAC3B,mFAAmF;EACrF;;EAEA;IACE,cAAc;IACd,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;IACtB,0BAA0B;EAC5B;AACF;;AAEA;uCACuC;AACvC;EACE,YAAY,aAAa,EAAE;AAC7B","sourcesContent":["/**\r\n * Lienzos a pantalla completa (Cableado › Tomas ↔ panel).\r\n *\r\n * Estas vistas no son listados: ocupan todo el alto útil entre las migas y el\r\n * borde inferior. Desde 2026-10-30 son rutas de `isCanvasRoute` (ver\r\n * `MainLayout.jsx`), así que el alto lo reparte el layout con flex y aquí no\r\n * hay `calc()` contra el viewport: un número fijo dejaba franjas muertas en\r\n * cuanto cambiaba el alto de la barra superior o de las migas.\r\n */\r\n\r\n.cabling-fullpage {\r\n  flex: 1;\r\n  height: 100%;\r\n  min-height: 0;\r\n  overflow: hidden;\r\n}\r\n\r\n/* ── Topología de virtualización ─────────────────────────────────────────\r\n   La barra tenía seis muestras de leyenda y cuatro botones en una fila que no\r\n   se podía ni envolver ni desplazar: en un móvil, «Resumen» quedaba a 800 px\r\n   de la pantalla. Ahora el título va en su línea, la leyenda se envuelve y los\r\n   botones bajan debajo. */\r\n@media (max-width: 900px) {\r\n  .vtc-page {\r\n    margin: -0.75rem !important;\r\n    height: calc(100dvh - var(--app-topbar-h) - var(--app-crumb-h) - 1.5rem) !important;\r\n  }\r\n\r\n  .vtc-toolbar {\r\n    flex-wrap: wrap;\r\n    gap: 8px !important;\r\n    padding: 8px 10px !important;\r\n  }\r\n\r\n  .vtc-title {\r\n    flex: 1 1 100%;\r\n    font-size: 0.86rem !important;\r\n  }\r\n\r\n  .vtc-legend {\r\n    flex: 1 1 100%;\r\n    flex-wrap: wrap;\r\n    gap: 4px 10px !important;\r\n  }\r\n}\r\n\r\n/* ── Topología de red (`NetworkTopologyCanvas`) ───────────────────────────\r\n   La leyenda medía 417 px y el SVG se salía 10 px del contenedor: en un móvil\r\n   se cortaban por la derecha. Ahora la leyenda envuelve y el SVG se ajusta al\r\n   ancho (el contenido se ve con pan y zoom). */\r\n@media (max-width: 900px) {\r\n  .ntop-page {\r\n    margin: -0.75rem !important;\r\n    height: calc(100dvh - var(--app-topbar-h) - var(--app-crumb-h) - 1.5rem) !important;\r\n  }\r\n\r\n  .ntop-legend {\r\n    flex: 1 1 100%;\r\n    gap: 4px 8px !important;\r\n  }\r\n\r\n  .ntop-svg {\r\n    width: 100% !important;\r\n    max-width: 100% !important;\r\n  }\r\n}\r\n\r\n/* Ayuda de uso del mapa de dependencias: en móvil el gesto es obvio y el texto\r\n   no cabe (se cortaba a la derecha). */\r\n@media (max-width: 768px) {\r\n  .sdm-hint { display: none; }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
